"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.createBusinessEvent = createBusinessEvent;

var _uuid = require("uuid");

var _ISS = require("../telemetry/ISS");

var _Telemetry = require("../telemetry/Telemetry");

var _scrubTelemetryData = require("./scrubTelemetryData");

function createBusinessEvent(operationName, resultDescription) {
  var correlationId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _uuid.v4)();
  var eventProperties = new _Telemetry.EventProperties();
  eventProperties.setProperty(_ISS.IssPropertyName.Action_OperationName, operationName);
  eventProperties.setProperty(_ISS.IssPropertyName.Caller_CorrelationId, correlationId);

  if (resultDescription) {
    eventProperties.setProperty(_ISS.IssPropertyName.Result_ResultDescription, (0, _scrubTelemetryData.scrubTelemetryData)(resultDescription));
  }

  return eventProperties;
}